import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent, Register } from '@xanadu/core';
import { Faction } from '@xanadu/model';
import { FactionCache } from '@xanadu/cache';

@Component({
    selector: 'app-faction-panel',
    templateUrl: './faction-panel.component.html',
    styleUrls: ['./faction-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('faction-panel')
export class FactionPanelComponent extends PanelComponent<Faction> {
    private readonly factionCache = inject(FactionCache);

    private tabFaction = { caption: 'Faction', active: true, hidden: false };

    protected override get nodeType(): string | undefined {
        return 'aspect';
    }

    protected override setup(faction: Faction): void {
        super.setup(faction);

        this.tabs = [
            this.tabFaction
        ];
        this.tabSelected = this.tabFaction;
    }

    protected override refresh(faction: Faction): void {
        super.refresh(faction);

        this.factionCache.update();
    }
}
